export let Languages = [
  { id: 1, name: "English", "iso_639-1": "en", name_ar: "انجليزي" },
  { id: 2, name: "Arabic", "iso_639-1": "ar", name_ar: "عربي" },
  { id: 3, name: "German", "iso_639-1": "de", name_ar: "ألماني" },
  { id: 4, name: "French", "iso_639-1": "fr", name_ar: "فرنسي" },
  { id: 5, name: "Turkish", "iso_639-1": "tr", name_ar: "تركي" },
  { id: 6, name: "Spanish", "iso_639-1": "es", name_ar: "إسباني" },
  { id: 7, name: "Russian", "iso_639-1": "ru", name_ar: "روسي" },
  { id: 8, name: "Italian", "iso_639-1": "it", name_ar: "إيطالي" },
  { id: 9, name: "Persian", "iso_639-1": "fa", name_ar: "فارسي" },
  { id: 10, name: "Hindi", "iso_639-1": "hi", name_ar: "هندي" },
];
